class GA4Provider {
  constructor() {
    this.name = "GA4_EVENT"
    this.track = this.track.bind(this)
  }

  initialize() {
    return true;
  }

  execute(payLoad) {
    const { eventName, eventCategory, eventAction, eventLabel, eventValue } = payLoad
    if (!eventName || typeof window === "undefined" || typeof window.gtag !== "function") {
      return
    }
    try {
      window.gtag('event', eventName, {
        'event_category': eventCategory,
        'event_action': eventAction,
        'event_label': eventLabel,
        'event_value': eventValue
      });
    } catch (error) {
      console.error(
        `[GA4] Failed to track "${eventName}"`,
        error
      );
    }
  }

  track(payload = {}) {
    this.execute(payload)
  }
  pageView(eventPayload) {
    this.execute(eventPayload)
  }
}

export default GA4Provider;